/**
 * Label Filter Context Definition
 *
 * Context for sharing label filter state across components.
 */

import { createContext } from 'react'
import type { LabelFilterContextValue } from '../types'

export const LabelFilterContext = createContext<LabelFilterContextValue | null>(null)
